if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
        this.hideErrors = this.dataset.hideErrors === 'true';
        this.addonVariantUnsubscriber = null;
        this.addonCartUnsubscriber = null;
        this.addonBindTimer = null;
        this.addonCartBindTimer = null;
        this.initAddonOffers();
        this.initAddonVisibility();
      }

      connectedCallback() {
        this.bindAddonVariantSync();
        this.bindAddonCartSync();
        this.giftStateChangedHandler = this.giftStateChangedHandler || (() => this.syncAddonCartState());
        document.addEventListener('modifika:gift-state-changed', this.giftStateChangedHandler);
        this.syncAddonCartState();
      }

      disconnectedCallback() {
        if (typeof this.addonVariantUnsubscriber === 'function') this.addonVariantUnsubscriber();
        if (typeof this.addonCartUnsubscriber === 'function') this.addonCartUnsubscriber();
        if (this.giftStateChangedHandler) document.removeEventListener('modifika:gift-state-changed', this.giftStateChangedHandler);
        window.clearTimeout(this.addonBindTimer);
        window.clearTimeout(this.addonCartBindTimer);
      }

      async onSubmitHandler(event) {
        event.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const formData = new FormData(this.form);
        const variantId = formData.get('id');
        let selectedAddons = this.getSelectedAddons();
        let addonFallbackMessage = '';

        if (this.cart) this.cart.setActiveElement(document.activeElement);

        try {
          selectedAddons = await this.filterAlreadyAddedCupholders(selectedAddons);
          let response = await this.addItems(formData, selectedAddons);

          if (response.status && selectedAddons.length) {
            response = await this.addItems(formData, []);
            if (!response.status) {
              addonFallbackMessage = 'O sofá foi adicionado, mas um dos complementos ficou indisponível. Revise o carrinho antes de finalizar.';
            }
          }

          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: variantId,
              errors: response.errors || response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;

            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButtonText.classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          if (addonFallbackMessage) this.handleErrorMessage(addonFallbackMessage);
          if (!addonFallbackMessage) this.markAddedCupholders(selectedAddons);
          this.resetAddonSelection();

          if (!this.cart) {
            document.dispatchEvent(
              new CustomEvent('modifika:product-added', {
                detail: { source: 'product-form', productVariantId: variantId, cartData: response },
              })
            );
            return;
          }

          const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
          if (!this.error) {
            await publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: variantId,
              cartData: response,
            });
            CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  CartPerformance.measure('add:paint-updated-sections', () => {
                    this.cart.renderContents(response);
                  });
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            CartPerformance.measure('add:paint-updated-sections', () => {
              this.cart.renderContents(response);
            });
          }

          document.dispatchEvent(
            new CustomEvent('modifika:product-added', {
              detail: { source: 'product-form', productVariantId: variantId, cartData: response },
            })
          );
        } catch (error) {
          console.error(error);
          this.handleErrorMessage('Não foi possível adicionar ao carrinho. Tente novamente.');
        } finally {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
          CartPerformance.measureFromEvent('add:user-action', event);
        }
      }

      async addItems(formData, addons = []) {
        const sections = this.cart ? this.cart.getSectionsToRender().map((section) => section.id) : [];
        const sectionsUrl = window.location.pathname;

        if (addons.length) {
          const payload = {
            items: [
              this.buildMainItem(formData),
              ...addons.map((addon) => {
                const item = {
                  id: addon.id,
                  quantity: 1,
                };

                if (addon.kind === 'brinde') {
                  item.properties = {
                    _mf_gift: '1',
                    _mf_gift_color: addon.title || '',
                    Brinde: 'Porta-copos grátis',
                  };
                }

                return item;
              }),
            ],
            sections,
            sections_url: sectionsUrl,
          };

          const response = await fetch(routes.cart_add_url, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify(payload),
          });
          return response.json();
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        if (this.cart) {
          formData.set('sections', sections.join(','));
          formData.set('sections_url', sectionsUrl);
        }
        config.body = formData;
        const response = await fetch(routes.cart_add_url, config);
        return response.json();
      }

      buildMainItem(formData) {
        const item = {
          id: Number(formData.get('id')),
          quantity: Math.max(1, Number(formData.get('quantity') || 1)),
        };
        const properties = {};

        for (const [key, value] of formData.entries()) {
          const match = key.match(/^properties\[(.*)\]$/);
          if (match && value !== '') properties[match[1]] = value;
          if (key === 'selling_plan' && value) item.selling_plan = Number(value);
        }

        if (Object.keys(properties).length) item.properties = properties;
        return item;
      }

      getSelectedAddons() {
        return Array.from(this.querySelectorAll('[data-mf-addon]'))
          .map((card) => {
            const toggle = card.querySelector('[data-mf-addon-toggle]');
            const variantId = Number(card.dataset.addonVariantId || 0);
            if (!toggle || !toggle.checked || toggle.disabled || !variantId) return null;
            return {
              id: variantId,
              productId: Number(card.dataset.addonProductId || 0),
              kind: card.dataset.addonKind || 'complemento',
              title: card.dataset.addonVariantTitle || '',
            };
          })
          .filter(Boolean);
      }

      async filterAlreadyAddedCupholders(addons = []) {
        const cupholderAddons = addons.filter((addon) => addon.kind === 'brinde' && addon.productId);
        if (!cupholderAddons.length) return addons;

        try {
          const response = await fetch(`${window.routes?.cart_url || '/cart'}.js`, {
            headers: { Accept: 'application/json' },
            cache: 'no-store',
          });
          if (!response.ok) return addons;
          const cartState = await response.json();
          const productIds = new Set((cartState.items || []).map((item) => Number(item.product_id || 0)));
          const filtered = addons.filter((addon) => addon.kind !== 'brinde' || !addon.productId || !productIds.has(addon.productId));

          if (filtered.length !== addons.length) {
            this.syncAddonCardsFromProductIds(productIds);
          }
          return filtered;
        } catch (error) {
          return addons;
        }
      }

      markAddedCupholders(addons = []) {
        const productIds = new Set(
          addons
            .filter((addon) => addon.kind === 'brinde' && addon.productId)
            .map((addon) => Number(addon.productId))
        );
        if (!productIds.size) return;
        this.syncAddonCardsFromProductIds(productIds, true);
        document.dispatchEvent(new CustomEvent('modifika:gift-state-changed', { detail: { hasGift: true } }));
      }

      bindAddonCartSync(attempt = 0) {
        if (!this.addonCards?.some((card) => card.dataset.addonIsCupholder === 'true') || this.addonCartUnsubscriber) return;

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          this.addonCartUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
            window.setTimeout(() => this.syncAddonCartState(), 0);
          });
          return;
        }

        if (attempt < 100 && this.isConnected) {
          this.addonCartBindTimer = window.setTimeout(() => this.bindAddonCartSync(attempt + 1), 50);
        }
      }

      async syncAddonCartState() {
        if (!this.addonCards?.some((card) => card.dataset.addonIsCupholder === 'true')) return;
        try {
          const response = await fetch(`${window.routes?.cart_url || '/cart'}.js`, {
            headers: { Accept: 'application/json' },
            cache: 'no-store',
          });
          if (!response.ok) return;
          const cartState = await response.json();
          const productIds = new Set((cartState.items || []).map((item) => Number(item.product_id || 0)));
          this.syncAddonCardsFromProductIds(productIds);
        } catch (error) {
          // Mantém a exibição definida pelo Liquid quando o carrinho não puder ser consultado.
        }
      }

      syncAddonCardsFromProductIds(productIds, onlyMarkPresent = false) {
        if (!this.addonCards?.length) return;
        this.addonCards.forEach((card) => {
          if (card.dataset.addonIsCupholder !== 'true') return;
          const productId = Number(card.dataset.addonProductId || 0);
          const inCart = Boolean(productId && productIds.has(productId));
          if (onlyMarkPresent && !inCart) return;
          this.setCupholderCardState(card, inCart);
        });
        this.refreshAddonOfferVisibility();
      }

      setCupholderCardState(card, inCart) {
        if (!card) return;
        card.dataset.addonInCart = String(Boolean(inCart));
        card.classList.toggle('is-in-cart', Boolean(inCart));
        card.hidden = Boolean(inCart);

        const toggle = card.querySelector('[data-mf-addon-toggle]');
        if (toggle) {
          toggle.checked = false;
          toggle.disabled = Boolean(inCart) || card.classList.contains('is-unavailable');
        }

        if (!inCart) {
          const currentVariant = (card.mfVariants || []).find(
            (variant) => String(variant.id) === String(card.dataset.addonVariantId || '')
          );
          if (currentVariant) this.applyAddonVariant(card, currentVariant);
        }
        this.updateAddonSelectionState(card, inCart ? 'Já está no carrinho' : '');
      }

      refreshAddonOfferVisibility() {
        const offer = this.querySelector('[data-mf-addon-offer]');
        if (!offer) return;
        const visibleCards = (this.addonCards || []).filter((card) => !card.hidden);
        offer.hidden = visibleCards.length === 0;

        visibleCards.forEach((card, index) => {
          card.classList.toggle('mf-addon-card--extra', index >= 2);
        });

        const button = offer.querySelector('[data-mf-addon-expand]');
        if (!button) return;
        const hiddenCount = Math.max(0, visibleCards.length - 2);
        button.hidden = hiddenCount === 0;
        button.dataset.collapsedLabel = hiddenCount === 1 ? 'Ver mais 1 opção' : `Ver mais ${hiddenCount} opções`;
        const text = button.querySelector('[data-mf-addon-expand-text]');
        if (text && !offer.classList.contains('is-expanded')) text.textContent = button.dataset.collapsedLabel;
      }

      initAddonVisibility() {
        const offer = this.querySelector('[data-mf-addon-offer]');
        const button = offer?.querySelector('[data-mf-addon-expand]');
        if (!offer || !button) return;

        const text = button.querySelector('[data-mf-addon-expand-text]');
        const expandedLabel = button.dataset.expandedLabel || 'Mostrar menos';

        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          const expanded = !offer.classList.contains('is-expanded');
          const collapsedLabel = button.dataset.collapsedLabel || 'Ver mais opções';
          offer.classList.toggle('is-expanded', expanded);
          button.setAttribute('aria-expanded', String(expanded));
          if (text) text.textContent = expanded ? expandedLabel : collapsedLabel;
        });
      }

      initAddonOffers() {
        this.addonCards = Array.from(this.querySelectorAll('[data-mf-addon]'));
        if (!this.addonCards.length) return;

        this.addonCards.forEach((card) => {
          const json = card.querySelector('[data-mf-addon-variants]');
          try {
            card.mfVariants = JSON.parse(json?.textContent || '[]');
          } catch (error) {
            console.warn('Não foi possível ler as variantes do complemento.', error);
            card.mfVariants = [];
          }

          const toggle = card.querySelector('[data-mf-addon-toggle]');
          if (toggle) {
            toggle.checked = false;
            toggle.addEventListener('change', () => this.updateAddonSelectionState(card));
          }

          const variantSelect = card.querySelector('[data-mf-addon-variant-select]');
          if (variantSelect) {
            ['click', 'mousedown', 'touchstart'].forEach((eventName) => {
              variantSelect.addEventListener(eventName, (event) => event.stopPropagation());
            });
            variantSelect.addEventListener('change', (event) => {
              event.stopPropagation();
              const variant = (card.mfVariants || []).find((item) => String(item.id) === String(variantSelect.value));
              this.applyAddonVariant(card, variant || null);
            });
          }
          this.updateAddonSelectionState(card);
        });

        this.syncAddonVariants(this.dataset.mfMainColor || '');
        this.refreshAddonOfferVisibility();
      }

      bindAddonVariantSync(attempt = 0) {
        if (!this.addonCards?.length || this.addonVariantUnsubscriber) return;

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
          this.addonVariantUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            const data = event?.data || {};
            if (data.sectionId && String(data.sectionId) !== String(this.dataset.sectionId)) return;
            const variant = data.variant || {};
            const selectedColor = Array.isArray(variant.options) ? variant.options[0] : variant.title;
            this.dataset.mfMainColor = selectedColor || '';
            this.syncAddonVariants(selectedColor || '');
          });
          return;
        }

        if (attempt < 100 && this.isConnected) {
          this.addonBindTimer = window.setTimeout(() => this.bindAddonVariantSync(attempt + 1), 50);
        }
      }

      syncAddonVariants(mainColor) {
        if (!this.addonCards?.length) return;
        const normalizedMainColor = this.normalizeColor(mainColor);

        this.addonCards.forEach((card) => {
          const variants = Array.isArray(card.mfVariants) ? card.mfVariants : [];
          const availableVariants = variants.filter((variant) => variant.available);
          const variantSelect = card.querySelector('[data-mf-addon-variant-select]');

          if (variantSelect) {
            const selectedVariant = availableVariants.find((variant) => String(variant.id) === String(variantSelect.value)) || availableVariants[0];
            if (selectedVariant) variantSelect.value = String(selectedVariant.id);
            this.applyAddonVariant(card, selectedVariant || null);
            return;
          }
          let matchedVariant = availableVariants.find((variant) => {
            const variantColor = Array.isArray(variant.options) ? variant.options[0] : variant.title;
            return this.normalizeColor(variantColor) === normalizedMainColor;
          });

          if (!matchedVariant && normalizedMainColor) {
            matchedVariant = availableVariants.find((variant) => {
              const normalizedVariant = this.normalizeColor(Array.isArray(variant.options) ? variant.options[0] : variant.title);
              return normalizedVariant.includes(normalizedMainColor) || normalizedMainColor.includes(normalizedVariant);
            });
          }

          // Produtos escolhidos pelo metacampo podem não ter uma variante de cor
          // correspondente ao sofá. Nesse caso, mantém a primeira variante disponível.
          if (!matchedVariant) matchedVariant = availableVariants[0];

          this.applyAddonVariant(card, matchedVariant || null);
        });
      }

      applyAddonVariant(card, variant) {
        const toggle = card.querySelector('[data-mf-addon-toggle]');
        const image = card.querySelector('[data-mf-addon-image]');
        const price = card.querySelector('[data-mf-addon-price]');
        const color = card.querySelector('[data-mf-addon-color]');
        const unavailable = card.querySelector('[data-mf-addon-unavailable]');

        if (!variant) {
          card.removeAttribute('data-addon-variant-id');
          card.classList.add('is-unavailable');
          if (toggle) {
            toggle.checked = false;
            toggle.disabled = true;
          }
          if (unavailable) unavailable.hidden = false;
          if (color) color.hidden = true;
          this.updateAddonSelectionState(card, 'Indisponível');
          return;
        }

        card.dataset.addonVariantId = String(variant.id);
        card.dataset.addonVariantTitle = variant.title || '';
        const variantSelect = card.querySelector('[data-mf-addon-variant-select]');
        if (variantSelect && String(variantSelect.value) !== String(variant.id)) variantSelect.value = String(variant.id);
        card.classList.remove('is-unavailable');
        if (toggle) toggle.disabled = card.dataset.addonInCart === 'true';
        if (unavailable) unavailable.hidden = true;

        if (image && variant.image) {
          image.src = variant.image;
          image.removeAttribute('srcset');
          image.alt = `${card.querySelector('.mf-addon-card__title')?.textContent?.trim() || 'Complemento'} — ${variant.title || 'Opção selecionada'}`;
        }
        if (price) {
          price.textContent = `+ ${variant.priceFormatted || this.formatMoney(variant.price)}`;
        }
        if (color) {
          color.hidden = false;
          color.textContent = `Opção: ${variant.title || 'Selecionada'}`;
        }

        this.updateAddonSelectionState(card);
      }

      updateAddonSelectionState(card, forcedText = '') {
        const toggle = card.querySelector('[data-mf-addon-toggle]');
        const actionText = card.querySelector('[data-mf-addon-action-text]');
        const selected = Boolean(toggle && toggle.checked && !toggle.disabled);
        card.classList.toggle('is-selected', selected);
        if (actionText) {
          actionText.textContent = forcedText || (card.dataset.addonInCart === 'true' ? 'Já está no carrinho' : selected ? 'Adicionado' : 'Adicionar');
        }
      }

      resetAddonSelection() {
        if (!this.addonCards?.length) return;
        this.addonCards.forEach((card) => {
          const toggle = card.querySelector('[data-mf-addon-toggle]');
          if (toggle) toggle.checked = false;
          this.updateAddonSelectionState(card);
        });
      }

      normalizeColor(value) {
        const normalized = String(value || '')
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase()
          .replace(/\bboucle\b/g, ' ')
          .replace(/\btecido\b/g, ' ')
          .replace(/\bcor\b/g, ' ')
          .replace(/\bpremium\b/g, ' ')
          .replace(/\d+/g, ' ')
          .replace(/[^a-z\s-]/g, ' ')
          .replace(/\s+/g, ' ')
          .trim();

        if (normalized.includes('bege claro')) return 'bege claro';
        if (normalized.includes('bege escuro')) return 'bege escuro';
        if (normalized.includes('verde menta')) return 'verde menta';
        if (normalized.includes('laranja')) return 'laranja';
        if (normalized.includes('cinza')) return 'cinza';
        return normalized;
      }

      cleanColorLabel(value) {
        return String(value || '')
          .replace(/boucl[ée]\s*/gi, '')
          .replace(/\s+\d+$/g, '')
          .trim();
      }

      formatMoney(cents) {
        const amount = Number(cents || 0) / 100;
        try {
          return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: window.Shopify?.currency?.active || 'BRL' }).format(amount);
        } catch (error) {
          return `R$ ${amount.toFixed(2).replace('.', ',')}`;
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;

        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) this.errorMessage.textContent = errorMessage;
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name="id"]');
      }
    }
  );
}
